import { ImpersonationBanner } from '@/components/auth/ImpersonationBanner';
import logo from '@/images/logo-black.svg';
import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

const StyledPage = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: var(--white-main);
  padding: 125px 100px 200px 100px;
  position: relative;
  overflow: hidden;
  text-align: center;

  .watermark {
    position: absolute;
    bottom: -40px;
    left: -29px;
    width: 105%;
    opacity: 0.03;
    pointer-events: none;
    z-index: 0;
  }

  .content {
    position: relative;
    z-index: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--big-padding);
  }

  .text-group {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: var(--xsmall-padding);
  }

  .clock-icon {
    width: 102px;
    height: 102px;
    opacity: 0.3;
  }

  .text-content {
    display: flex;
    flex-direction: column;
    gap: var(--medium-big-padding);
    max-width: 613px;
  }

  h1 {
    font-size: 40px;
    line-height: 1.3;
    font-weight: 700;
    margin: 0;
  }

  p {
    font-size: 16px;
    line-height: 1.5;
    margin: 0;
  }
`;

const ClockIcon = () => (
  <svg
    className="clock-icon"
    viewBox="0 0 102 102"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <circle cx="51" cy="51" r="48" stroke="currentColor" strokeWidth="3" />
    <line
      x1="51"
      y1="20"
      x2="51"
      y2="51"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <line
      x1="51"
      y1="51"
      x2="70"
      y2="51"
      stroke="currentColor"
      strokeWidth="3"
      strokeLinecap="round"
    />
  </svg>
);

export const PendingAccessScreen: React.FC = () => {
  const { t } = useTranslation();

  return (
    <>
      <ImpersonationBanner />
      <StyledPage translate="no">
        <img className="watermark" src={logo} alt="" aria-hidden="true" />
        <div className="content">
          <div className="text-group">
            <ClockIcon />
            <div className="text-content">
              <h1>{t('pendingAccess.heading')}</h1>
              <p>{t('pendingAccess.body.paragraph1')}</p>
              <p>{t('pendingAccess.body.paragraph2')}</p>
            </div>
          </div>
        </div>
      </StyledPage>
    </>
  );
};
